/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTariffRegionLtlZipLoc.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/tariff-region-ltl-zip-loc";

export class AutogenModelTariffRegionLtlZipLoc<RowType extends ModelRow> extends Endpoint<RowType, RowTariffRegionLtlZipLocFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTariffRegionLtlZipLoc extends ModelRow<RowTariffRegionLtlZipLocFields> {
	constructor(values?: Partial<RowTariffRegionLtlZipLocFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTariffRegionLtlZipLocFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	effective_date: Date;
	effective_timestamp: Date;
	exchange_point_plc_uid: number;
	expiration_date: Date;
	expire_timestamp: Date;
	fd_zipcode: string;
	id: string;
	interline_assign_type_code: string;
	interline_plc_uid: number;
	location_id: string;
	location_type: string;
	mod_timestamp: Date;
	mod_userid: string;
	parent_reg_name: string;
	parent_reg_uid: number;
	reg_type_code: string;
	reg_uid: number;
	region_gl_digits: string;
	region_name: string;
	region_nickname: string;
	rxz_type_code: string;
	rxz_uid: number;
	service_type_code: string;
	state_id: string;
}

